import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./App.css";
import AuthenticatedApp from "./app/authenticatedApp";
import UnAuthenticatedApp from "./app/unAuthenticatedApp";
import FullPageLoader from "./components/fullPageLoader";
import { authSetUser } from "./store/actions/authAction";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

function App() {
  const queryClient = new QueryClient();
  const dispatch = useDispatch();
  const isLoggedIn = useSelector((state) => state?.auth?.isLoggedIn);
  // const isLoggedIn = useSelector(state=>state?.auth?.isLoggedIn)
  const [checkingStatus, setCheckingStatus] = useState(true);
  //check if user is authenticated and get his details and store to global state
  useEffect(() => {
    // Handle user state changes
    const stored = localStorage.getItem("WMS_USER");

    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        dispatch(authSetUser({ ...parsed }));
      } catch (e) {
        localStorage.removeItem("WMS_USER");
        localStorage.removeItem("WMS#221#");
      }
    } else {
      localStorage.removeItem("WMS#221#");
    }

    if (checkingStatus) setCheckingStatus(false);
  }, [checkingStatus, dispatch]);
  // End check !!

  if (checkingStatus) {
    return <FullPageLoader />;
  }

  if (isLoggedIn) {
    return (
      <QueryClientProvider client={queryClient}>
        <AuthenticatedApp />
      </QueryClientProvider>
    );
  }

  return <UnAuthenticatedApp />;
}

export default App;
